/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SportBallTennisIcon24Solid = forwardRef('SportBallTennisIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M2.113 10.49a10.007 10.007 0 0 1 8.377-8.377 9.09 9.09 0 0 1-2.644 5.732 9.089 9.089 0 0 1-5.733 2.645Z" }),
        React.createElement("path", { d: "M9.083 9.083a10.835 10.835 0 0 0 3.168-7.08c5.323.131 9.614 4.422 9.746 9.745a10.835 10.835 0 0 0-7.08 3.168 10.834 10.834 0 0 0-3.168 7.08c-5.324-.13-9.615-4.422-9.746-9.745a10.835 10.835 0 0 0 7.08-3.168Z" }),
        React.createElement("path", { d: "M21.887 13.51a10.007 10.007 0 0 1-8.377 8.377 9.09 9.09 0 0 1 2.644-5.733 9.089 9.089 0 0 1 5.733-2.645Z" })));
});
